export type InspectionParticipantCardTokens = {
	background: string;
	borderRadius: string;
	boxShadow: string;
	padding: string;
	gap: string;
};

/**
 * Participant step card wrapper — Figma 5964-135983.
 * Uses semantic form.field.shadow (same effect as Figma: 0 1px 2px).
 */
export default {
	background: '{surface.0}',
	borderRadius: '0',
	boxShadow: '{form.field.shadow}',
	padding: '24px',
	gap: '2rem',
} satisfies InspectionParticipantCardTokens;
